import { render, staticRenderFns } from "./IconSvgLibrary.vue?vue&type=template&id=4ffbb330&scoped=true&"
import script from "./IconSvgLibrary.vue?vue&type=script&lang=js&"
export * from "./IconSvgLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffbb330",
  null
  
)

export default component.exports